import { IScheduler } from '../../../interfaces/scheduler_interfaces';
import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export type SchedulerModel = ITypedModel<IScheduler>;

angular.module('capability-ng-scheduler').factory('ngSchedulerModel', () => {
  return new Model<IScheduler>({
    channel_name: '',
    in_state_credit_cost: 0,
    customtext: {
      SECTION_PIN_TEXT: {
        text: 'Section PIN',
        nk: 'SECTION_PIN_TEXT'
      },
      PAY_TUITION_URL: {
        text: '',
        nk: 'PAY_TUITION_URL'
      },
      SIS_REGISTRATION_URL: {
        text: '',
        nk: 'SIS_REGISTRATION_URL'
      },
      INSTITUTION_NAME: {
        text: '',
        nk: 'INSTITUTION_NAME'
      },
      LAST_DAY_TO_DROP: {
        text: 'Last day to drop without penalty:',
        nk: 'LAST_DAY_TO_DROP'
      },
      NO_TIMES_AVAILABLE: {
        text: 'No times available. Times are not yet loaded for this course. Check back soon.',
        nk: 'NO_TIMES_AVAILABLE'
      }
    },
    precheck_pass: false
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/models/scheduler_model.ts